import React from 'react';

const PageBreak = () => (
  <svg
    width="23"
    height="29"
    viewBox="0 0 23 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.8125 14.5H22.1875"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
    />
    <path
      d="M11.5 11.6875V1.5625"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M16 6.0625L11.5 1.5625L7 6.0625"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M11.5 17.3125V27.4375"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M7 22.9375L11.5 27.4375L16 22.9375"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default PageBreak;
